import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import KanbanBoard from "src/components/KanbanBoard";
import Navigator from "src/components/Navigator";
import KanbanBoardService from "src/modules/3rd-party-management/apis/admin/KanbanBoardService";
import {
    TasksStatuses,
    TasksPriorities,
} from "src/modules/3rd-party-management/constants";
import FilteringComponent from "./components/FilteringComponent";

const SupplierKanbanBoard = ({ t }) => {
    const fetchBoardData = async (filters) => {
        const service = KanbanBoardService.getInstance();
        return await service.fetchList(filters);
    };

    const getTaskLink = (data) => {
        if (!data?.supplier?.id || !data?.id) {
            return "#";
        }

        return `/admin/3rd-party/suppliers/${data.supplier.id}/tasks/${data.id}/details`;
    };

    const renderTaskId = (data) => {
        const supplier = data?.supplier || {};
        const isOwnCompany = !!supplier.isOwnCompany;
        const isMitigation = !!(data?.isMitigation || data?.relatedRisk?.isMitigation);

        let taskFullID = `#${isOwnCompany ? "E" : "TP"}${supplier.secondaryId || ""}`;

        if (isMitigation) {
            taskFullID += `/R${data?.relatedRisk?.secondaryId || ""}`;
        }

        taskFullID += `/T${data?.secondaryId || ""}`;

        return taskFullID;
    };

    const renderSubtitle = (data, translate) => {
        if (!data?.supplier) {
            return null;
        }

        const isOwnCompany = !!data.supplier.isOwnCompany;

        return (
            <div
                className="mb-4"
                style={{
                    borderLeft: "4px solid #eee",
                    paddingLeft: 20,
                    color: "#999",
                }}
            >
                <p className="mb-1">
                    {`${isOwnCompany ? translate("Entity ID") : translate("Supplier ID")}: ${
                        data.supplier?.secondaryId || ""
                    }`}
                </p>
                <p className="mb-1">
                    {`${isOwnCompany ? translate("Entity Name") : translate("Supplier Name")}: ${
                        data.supplier?.name || ""
                    }`}
                </p>
            </div>
        );
    };

    return (
        <div className="page-content supplier-kanban-board-page">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator pageTitle={t("Kanban Board")} translate={false} />
                    </Col>
                </Row>

                <KanbanBoard
                    boardWrapperClassName="d-flex"
                    queryKey={["3rd-party-management-fetch-kanboard-tasks-list-query"]}
                    fetchBoardData={fetchBoardData}
                    statuses={TasksStatuses}
                    priorities={TasksPriorities}
                    FilteringComponent={FilteringComponent}
                    getTaskLink={getTaskLink}
                    renderTaskId={renderTaskId}
                    renderSubtitle={renderSubtitle}
                />
            </Container>
        </div>
    );
};

const mapStatetoProps = (state) => {
    const { Organization } = state;

    return {
        user: state.Login.user,
        organization: Organization,
    };
};

export default withNamespaces()(
    withRouter(
        connect(
            mapStatetoProps,
            {}
        )(SupplierKanbanBoard)
    )
);
